<template>
    <div ref="searchSaveRef" class="search-save">
        <button
            ref="bookmarkButtonRef"
            @click="toggleDropdown"
            class="bookmark-btn"
            :class="{
                'bookmark-btn--saved': isSavedMatch,
                'bookmark-btn--animate-success': shouldAnimateBookmark
            }"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 16 16">
                <path v-if="isSavedMatch"
                    d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2z" />
                <path v-else
                    d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z" />
            </svg>
        </button>

        <!-- Dropdown no Auth -->
           <div v-if="isDropdownOpen" class="dropdown-overlay" @click="closeDropdown">
            <div v-if="!isAuthenticated" class="dropdown-content" @click.stop>
                <button type="button" @click="triggerLogin" class="dropdown-item">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
                    </svg>
                    Please login to use this feature
                </button>
            </div>
           </div>


        <!-- Dropdown w/ Auth -->
        <span v-if="isAuthenticated">
        <div v-if="isDropdownOpen" class="dropdown-overlay" @click="closeDropdown">
            <div class="dropdown-content" @click.stop>
                <button @click="openModal" class="dropdown-item">
                    <span class="plus-icon">+</span>
                    {{ isSavedMatch ? 'Update saved search' : 'Create saved search' }}
                </button>
                <button v-if="isSavedMatch" @click="openDeleteConfirmModal" class="dropdown-item dropdown-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1 0-2H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11z"/>
                    </svg>
                    Remove saved search
                </button>
                <button @click="openSavedSearches" class="dropdown-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        viewBox="0 0 16 16">
                        <path
                            d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z" />
                    </svg>
                    My saved searches
                </button>
            </div>
        </div>
        </span>

        <!-- Modal -->
        <div v-if="isModalOpen" class="modal-overlay" @click="closeModal">
            <div ref="modalContainerRef" class="modal-container" @click.stop>
                <!-- Close button top right -->
                <button @click="closeModal" class="close-button">
                    Close ✕
                </button>

                <!-- Modal content -->
                <div class="modal-content">
                    <h2 class="modal-title">
                        {{ isUpdateMode ? 'Update your search request' : 'Save your search request' }}
                    </h2>

                    <div class="form-group">
                        <label for="search-name">Search Name</label>
                        <input id="search-name" v-model="searchName" type="text" class="form-control"
                            :class="{ 'form-control--suggestion': isDefaultNameSuggestion }"
                            placeholder="Name your search" />
                    </div>

                    <div class="form-group">
                        <label for="search-term">Search Term</label>
                        <input id="search-term" :value="currentQuery" type="text" class="form-control" />
                    </div>


                    <div class="form-group">
                        <label for="search-query">Complete query URL </label>
                        <input id="search-query" v-model="searchQuery" type="text"
                            class="form-control form-control--readonly-query" readonly tabindex="-1"
                            placeholder="e mobility in europe" />
                    </div>

                    <!-- Save button bottom left -->
                    <div class="save-modal-footer">
                        <button @click="saveSearch" class="btn btn-primary save-button mt-3">
                            {{ isUpdateMode ? 'Update' : 'Save' }}
                        </button>
                        <button v-if="isUpdateMode" @click="closeModal"
                            class="btn ecl-button ecl-button--secondary mr-2 cancel-button mt-3">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isDeleteConfirmOpen" class="confirm-modal-overlay" @click="closeDeleteConfirmModal">
            <div class="confirm-modal" @click.stop role="dialog" aria-modal="true" aria-labelledby="delete-confirm-title">
                <h3 id="delete-confirm-title" class="confirm-modal__title">Remove saved search?</h3>
                <p class="confirm-modal__text">Do you really want to remove this search?</p>
                <div class="confirm-modal__actions">
                    <button
                        @click="confirmDeleteSearch"
                        class="confirm-modal__btn confirm-modal__btn--danger"
                        :disabled="isDeletingSearch"
                    >
                        {{ isDeletingSearch ? 'Removing...' : 'Remove' }}
                    </button>
                    <button
                        @click="closeDeleteConfirmModal"
                        class="confirm-modal__btn confirm-modal__btn--cancel"
                        :disabled="isDeletingSearch"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>

        <div v-if="isDashboardActivationModalOpen" class="modal-overlay" @click="closeDashboardActivationModal">
            <div class="modal-container" @click.stop>
                <button @click="closeDashboardActivationModal" class="close-button">
                    Close ✕
                </button>
                <div class="modal-content">
                    <h2 class="modal-title">Dashboard activation required</h2>
                    <p class="activation-modal__text">
                        To use this feature, your account needs to be activated in the User Dashboard.
                    </p>
                    <div class="save-modal-footer">
                        <button @click="openDashboardActivationPage" class="btn btn-primary save-button mt-3">
                            Activate for Dashboard
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <span
            v-if="showSavePulse"
            class="bookmark-save-pulse"
            :style="savePulseStyle"
            aria-hidden="true"
        />
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed, watch, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import { usePvAuth } from '@deu/piveau-hub-ui-plugin-auth'
import { useStore } from 'vuex'
import axios from 'axios';

const instance = getCurrentInstance()

// Reactive data
const searchName = ref('')
const searchQuery = ref('')
const searchDescription = ref('')
const mockToken = ref('')
const isModalOpen = ref(false)
const isDropdownOpen = ref(false)
const isUpdateMode = ref(false)
const updateSearchId = ref('')
const savedSearchMatch = ref(null)
const savedSearchesResponse = ref(null)
const isLoadingSavedSearches = ref(false)
const isDeletingSearch = ref(false)
const isDeleteConfirmOpen = ref(false)
const isDashboardActivationModalOpen = ref(false)
const hasInteractedWithSaveSearch = ref(false)
const shouldAnimateBookmark = ref(false)
const showSavePulse = ref(false)
const savePulseStyle = ref({})
const bookmarkButtonRef = ref(null)
const searchSaveRef = ref(null)
const modalContainerRef = ref(null)
const DASHBOARD_AUDIENCE = instance?.appContext?.config?.globalProperties?.$env?.authentication?.login?.dashboardAudience || ''
const DASHBOARD_IDP = 'eulogin'
// Temporary production safeguard: skip dashboard activation probe so saved-search matching GETs are not blocked.
const BYPASS_DASHBOARD_ACTIVATION_CHECK = true
const normalizeBaseUrl = (url) => (url ? url.replace(/\/+$/, '') : '')
const dashboardBaseUrl = normalizeBaseUrl(
    instance?.appContext?.config?.globalProperties?.$env?.dashboard?.baseUrl )
const savedSearchJsonApiBase = `${dashboardBaseUrl}/editorial/jsonapi/saved-searches/combined`
const savedSearchRestApiBase = `${dashboardBaseUrl}/api/v1/saved-search`
const dashboardUserMeApiBase = `${dashboardBaseUrl}/api/v1/user/me`

const route = useRoute()
const store = useStore()

const pvAuth = usePvAuth()
const isAuthenticated = computed(() => {
    if (!pvAuth) return false
    return pvAuth.authData.value.isAuthenticated
})

const isAuthBootstrapReady = computed(() => {
    if (!isAuthenticated.value) return false
    const authState = pvAuth?.authData?.value
    if (!authState) return false

    const hasResolvedUsername = typeof authState.username === 'string' && authState.username.trim().length > 0
    return Boolean(authState.idTokenParsed) || hasResolvedUsername
})

const isAuthTokenReady = computed(() => {
    if (!isAuthenticated.value) return false
    const authState = pvAuth?.authData?.value
    const rpt = typeof authState?.rpt === 'string' ? authState.rpt.trim() : ''
    return rpt.length > 0
})

const currentQuery = computed(() => route.query.query || '')
const hasSearchToCheck = computed(() => (currentQuery.value || '').trim().length > 0)
const isDefaultNameSuggestion = computed(() => {
    if (isUpdateMode.value) return false
    return (searchName.value || '').trim() === (currentQuery.value || '').trim()
})
const currentSearchUrl = computed(() => {
    if (typeof window === 'undefined') return route.fullPath || ''
    return `${window.location.origin}${route.fullPath || ''}`
})
const isSavedMatch = computed(() => !!savedSearchMatch.value)

const dashboardActivationLink = computed(() => {
    if (!dashboardBaseUrl) return 'https://data.europa.eu/dashboard/en/user/'

    try {
        return new URL('/en/user/', `${dashboardBaseUrl}/`).toString()
    } catch {
        return `${dashboardBaseUrl}/en/user/`
    }
})

let dashboardTokenPromise = null
let drupalCsrfTokenPromise = null
let dashboardActivationCheckPromise = null
let silentMatchLoadTimeout = null
const dashboardActivationStatus = ref('unknown')
const dashboardActivationCheckedUser = ref('')

const getDashboardUserIdentity = () => {
    const authState = pvAuth?.authData?.value
    const subject = authState?.idTokenParsed?.sub
    if (typeof subject === 'string' && subject.trim().length > 0) return subject.trim()

    const username = authState?.username
    if (typeof username === 'string' && username.trim().length > 0) return username.trim()

    return ''
}

const markDashboardUserInactive = (userIdentity = '') => {
    dashboardActivationStatus.value = 'inactive'
    dashboardActivationCheckedUser.value = userIdentity || getDashboardUserIdentity()
}

const clearSilentMatchLoadTimeout = () => {
    if (silentMatchLoadTimeout && typeof window !== 'undefined') {
        window.clearTimeout(silentMatchLoadTimeout)
    }
    silentMatchLoadTimeout = null
}

const scheduleSilentMatchLoad = () => {
    if (typeof window === 'undefined') return
    clearSilentMatchLoadTimeout()

    // Defer match lookup slightly so auth startup token/refresh requests can settle first.
    silentMatchLoadTimeout = window.setTimeout(() => {
        if (!isAuthenticated.value) return
        if (!isAuthBootstrapReady.value) return
        if (!isAuthTokenReady.value) return
        if (!hasSearchToCheck.value) return
        loadSavedSearchMatch()
    }, 900)
}

const buildMiddlewareHeaders = () => {
    if (typeof window === 'undefined') return {}
    const csrf = window.localStorage.getItem('piveau-hub-ui-plugin-auth--csrf') || ''
    return csrf ? { 'X-PIVEAU-CSRF-PROTECTION': csrf } : {}
}

const fetchDashboardToken = async ({ forceRefresh = false } = {}) => {
    if (!pvAuth?.apiClient?.token) return ''

    if (forceRefresh) {
        dashboardTokenPromise = null
    }

    if (!dashboardTokenPromise) {
        dashboardTokenPromise = pvAuth.apiClient
            .token({
                audience: DASHBOARD_AUDIENCE,
                idp: DASHBOARD_IDP
            }, {
                headers: buildMiddlewareHeaders(),
                withCredentials: true
            })
            .then((response) => response?.access_token || '')
            .catch((error) => {
                console.warn('Could not fetch dashboard token for saved searches:', error)
                return ''
            })
            .finally(() => {
                dashboardTokenPromise = null
            })
    }

    return dashboardTokenPromise
}

const fetchDrupalCsrfToken = async ({ forceRefresh = false } = {}) => {
    if (!dashboardBaseUrl) return ''

    if (forceRefresh) {
        drupalCsrfTokenPromise = null
    }

    if (!drupalCsrfTokenPromise) {
        drupalCsrfTokenPromise = axios
            .get(`${dashboardBaseUrl}/session/token`, {
                headers: {
                    Accept: 'text/plain'
                },
                withCredentials: true,
                responseType: 'text'
            })
            .then((response) => {
                const token = typeof response?.data === 'string' ? response.data.trim() : ''
                return token || ''
            })
            .catch((error) => {
                console.warn('Could not fetch Drupal CSRF token for saved searches:', error)
                return ''
            })
            .finally(() => {
                drupalCsrfTokenPromise = null
            })
    }

    return drupalCsrfTokenPromise
}

const getAuthHeaders = (token, contentType = 'application/json', csrfToken = '') => ({
    'Content-Type': contentType,
    'Authorization': `Bearer ${token}`,
    ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {})
})

const executeCookielessRequest = async ({ url, method = 'POST', headers = {}, payload } = {}) => {
    if (typeof window === 'undefined') {
        throw new Error('Cookieless requests are only available in browser context')
    }

    const response = await fetch(url, {
        method,
        headers,
        credentials: 'omit',
        ...(typeof payload === 'undefined' ? {} : { body: JSON.stringify(payload) })
    })

    const contentType = response.headers.get('content-type') || ''
    let responseData = null

    if (contentType.includes('application/json') || contentType.includes('+json')) {
        responseData = await response.json().catch(() => null)
    } else {
        responseData = await response.text().catch(() => null)
    }

    if (!response.ok) {
        const requestError = new Error(`Request failed with status ${response.status}`)
        requestError.response = {
            status: response.status,
            data: responseData
        }
        throw requestError
    }

    return {
        status: response.status,
        data: responseData
    }
}

const readTextValue = (value) => {
    if (typeof value === 'string') {
        const trimmed = value.trim()
        return trimmed.length > 0 ? trimmed : ''
    }

    if (Array.isArray(value)) {
        for (const entry of value) {
            const normalized = readTextValue(entry)
            if (normalized) return normalized
        }
        return ''
    }

    if (value && typeof value === 'object') {
        if (Object.prototype.hasOwnProperty.call(value, 'value')) {
            return readTextValue(value.value)
        }

        // Support localized or indexed payloads, e.g. { en: 'Name' } or { 0: { value: 'Name' } }
        for (const nestedValue of Object.values(value)) {
            const normalized = readTextValue(nestedValue)
            if (normalized) return normalized
        }

        return ''
    }

    return ''
}

const getSavedSearchTitle = (savedSearch) => {
    const attributes = savedSearch?.attributes || {}
    // Prefer Drupal's normalized label for displaying the saved-search name.
    return readTextValue(attributes.label)
        || readTextValue(attributes.field_title)
        || readTextValue(attributes.title)
        || readTextValue(attributes.name)
        || readTextValue(savedSearch?.title)
        || readTextValue(savedSearch?.name)
        || readTextValue(savedSearch?.label)
        || ''
}

const normalizeComparisonUrl = (value) => {
    if (typeof value !== 'string') return ''
    const trimmed = value.trim()
    if (!trimmed) return ''

    try {
        const parsed = new URL(trimmed, typeof window !== 'undefined' ? window.location.origin : 'https://example.com')
        const normalizedPath = parsed.pathname.replace(/\/+$/, '') || '/'
        const sortedParams = new URLSearchParams(parsed.search)
        const orderedEntries = Array.from(sortedParams.entries()).sort(([aKey, aValue], [bKey, bValue]) => {
            if (aKey === bKey) return aValue.localeCompare(bValue)
            return aKey.localeCompare(bKey)
        })
        const normalizedParams = new URLSearchParams(orderedEntries)
        const queryString = normalizedParams.toString()
        return `${parsed.origin}${normalizedPath}${queryString ? `?${queryString}` : ''}`
    } catch {
        return trimmed.replace(/\/+$/, '')
    }
}

const ensureDataPath = (value) => {
    if (typeof value !== 'string') return ''
    const trimmed = value.trim()
    if (!trimmed) return ''

    try {
        const parsed = new URL(trimmed, typeof window !== 'undefined' ? window.location.origin : 'https://example.com')
        const path = parsed.pathname || '/'
        const normalizedPath = path === '/data' || path.startsWith('/data/')
            ? path
            : `/data${path.startsWith('/') ? '' : '/'}${path}`
        parsed.pathname = normalizedPath.replace(/\/+/g, '/')
        return `${parsed.origin}${parsed.pathname}${parsed.search}${parsed.hash}`
    } catch {
        return trimmed
    }
}

// Methods
const ensureDashboardUserActivated = async () => {
    if (!isAuthenticated.value) return false
    if (BYPASS_DASHBOARD_ACTIVATION_CHECK) return true
    if (!dashboardBaseUrl || !dashboardUserMeApiBase) return true

    const userIdentity = getDashboardUserIdentity()
    const isSameUser = userIdentity && dashboardActivationCheckedUser.value === userIdentity

    if (isSameUser && dashboardActivationStatus.value === 'active') return true
    if (isSameUser && dashboardActivationStatus.value === 'inactive') return false

    if (!dashboardActivationCheckPromise) {
        dashboardActivationCheckPromise = (async () => {
            try {
                let token = mockToken.value || await fetchDashboardToken()
                if (!token) return true

                try {
                    await axios.get(dashboardUserMeApiBase, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    })
                } catch (error) {
                    const status = error?.response?.status
                    if (status !== 401 && status !== 403) throw error

                    // Retry with a fresh token and no cookies to avoid stale token and Drupal-session precedence.
                    token = await fetchDashboardToken({ forceRefresh: true })
                    if (!token) throw error
                    await executeCookielessRequest({
                        url: dashboardUserMeApiBase,
                        method: 'GET',
                        headers: getAuthHeaders(token)
                    })
                }

                dashboardActivationStatus.value = 'active'
                dashboardActivationCheckedUser.value = userIdentity
                return true
            } catch (error) {
                const status = error?.response?.status
                if (status === 401) {
                    markDashboardUserInactive(userIdentity)
                    return false
                }

                if (status === 403) {
                    console.warn('Dashboard activation check returned 403 even after fallback. Keeping activation state unchanged.', error)
                    return true
                }

                console.warn('Could not validate dashboard activation status:', error)
                return true
            } finally {
                dashboardActivationCheckPromise = null
            }
        })()
    }

    return dashboardActivationCheckPromise
}

const toggleDropdown = async () => {
    if (!isDropdownOpen.value && isAuthenticated.value) {
        const isDashboardUserActive = await ensureDashboardUserActivated()
        if (!isDashboardUserActive) {
            isDashboardActivationModalOpen.value = true
            isDropdownOpen.value = false
            return
        }
    }

    isDropdownOpen.value = !isDropdownOpen.value

    if (isDropdownOpen.value && isAuthenticated.value) {
        hasInteractedWithSaveSearch.value = true
        loadSavedSearchMatch({ interactive: true })
    }
}

const closeDropdown = () => {
    isDropdownOpen.value = false
}

const triggerLogin = async () => {
    closeDropdown()
    if (!pvAuth?.login) return

    try {
        await pvAuth.login()
    } catch (error) {
        console.error('Error while logging in from search save dropdown:', error)
        store.dispatch('snackbar/showSnackbar', {
            message: `An error occurred while attempting to move to the login page: ${error?.message || 'Unknown error'}`,
            variant: 'error'
        })
    }
}

const handleDocumentPointerDown = (event) => {
    if (!isDropdownOpen.value) return

    const root = searchSaveRef.value
    const target = event?.target
    if (!root || !target) return

    if (!root.contains(target)) {
        closeDropdown()
    }
}

const closeModal = () => {
    isModalOpen.value = false
    isUpdateMode.value = false
    updateSearchId.value = ''
    searchName.value = ''
    searchDescription.value = ''
    mockToken.value = ''
}

const closeDashboardActivationModal = () => {
    isDashboardActivationModalOpen.value = false
}

const openDashboardActivationPage = () => {
    if (typeof window === 'undefined') return
    window.open(dashboardActivationLink.value, '_blank', 'noopener,noreferrer')
    closeDashboardActivationModal()
}

const openModal = async () => {
    hasInteractedWithSaveSearch.value = true

    if (isAuthenticated.value) {
        await loadSavedSearchMatch({ interactive: true })
    }

    if (savedSearchMatch.value) {
        isUpdateMode.value = true
        updateSearchId.value = savedSearchMatch.value.id || ''
        searchName.value = getSavedSearchTitle(savedSearchMatch.value) || currentQuery.value || 'Saved search'
        searchQuery.value = savedSearchMatch.value.attributes?.field_search_url?.uri
            || savedSearchMatch.value.attributes?.field_search_string
            || currentSearchUrl.value
    } else {
        isUpdateMode.value = false
        updateSearchId.value = ''
        searchName.value = currentQuery.value
        searchQuery.value = currentSearchUrl.value
    }

    mockToken.value = ''
    closeDropdown()
    isModalOpen.value = true
}

const openSavedSearches = () => {
    window.open(dashboardBaseUrl + '/user', '_blank')
    closeDropdown()
}

const openDeleteConfirmModal = () => {
    if (!isSavedMatch.value) return
    isDeleteConfirmOpen.value = true
}

const closeDeleteConfirmModal = () => {
    if (isDeletingSearch.value) return
    isDeleteConfirmOpen.value = false
}

const confirmDeleteSearch = async () => {
    await deleteSearch()
}

const loadSavedSearchMatch = async ({ interactive = false, preserveExistingMatch = false } = {}) => {
    try {
        if (isLoadingSavedSearches.value) return
        if (!isAuthenticated.value) return
        if (!interactive && !hasSearchToCheck.value) {
            if (!isModalOpen.value && !preserveExistingMatch) {
                savedSearchMatch.value = null
                isUpdateMode.value = false
                updateSearchId.value = ''
                searchName.value = ''
                searchQuery.value = currentSearchUrl.value
            }
            return
        }

        isLoadingSavedSearches.value = true

        const executeSavedSearchListRequest = async (token, omitCookies = false) => {
            if (omitCookies) {
                return await executeCookielessRequest({
                    url: savedSearchJsonApiBase,
                    method: 'GET',
                    headers: getAuthHeaders(token)
                })
            }

            return await axios.get(savedSearchJsonApiBase, {
                headers: getAuthHeaders(token)
            })
        }

        let token = mockToken.value || await fetchDashboardToken()
        if (!token) {
            savedSearchMatch.value = null
            return
        }

        let response
        try {
            response = await executeSavedSearchListRequest(token)
        } catch (error) {
            const status = error?.response?.status
            if (status === 401 || status === 403) {
                // Retry with a fresh token and omit cookies to avoid Drupal session-cookie precedence.
                token = await fetchDashboardToken({ forceRefresh: true })
                if (!token) throw error
                response = await executeSavedSearchListRequest(token, true)
            } else {
                throw error
            }
        }

        savedSearchesResponse.value = response.data || null

        const items = Array.isArray(response.data?.data) ? response.data.data : []
        const normalizedCurrentUrl = normalizeComparisonUrl(ensureDataPath(currentSearchUrl.value))
        const match = items.find(item => {
            const attributes = item?.attributes || {}
            const savedUrl = attributes.field_search_url?.uri || attributes.field_search_string
            const normalizedSavedUrl = normalizeComparisonUrl(ensureDataPath(savedUrl))
            return normalizedSavedUrl === normalizedCurrentUrl
        })

        savedSearchMatch.value = match || null

        if (match && !isModalOpen.value) {
            isUpdateMode.value = true
            updateSearchId.value = match.id || ''
            searchName.value = getSavedSearchTitle(match) || currentQuery.value || 'Saved search'
            searchQuery.value = match.attributes?.field_search_url?.uri
                || match.attributes?.field_search_string
                || currentSearchUrl.value
        }

        if (!match && !isModalOpen.value) {
            if (!preserveExistingMatch) {
                isUpdateMode.value = false
                updateSearchId.value = ''
                searchName.value = ''
                searchQuery.value = currentSearchUrl.value
            }
        }
    } catch (error) {
        console.error('Error loading saved searches:', error)
        savedSearchMatch.value = null
        savedSearchesResponse.value = {
            error: error?.message || 'Unknown error'
        }
    } finally {
        isLoadingSavedSearches.value = false
    }
}

const triggerBookmarkSuccessAnimation = () => {
    shouldAnimateBookmark.value = false
    requestAnimationFrame(() => {
        shouldAnimateBookmark.value = true
    })
    window.setTimeout(() => {
        shouldAnimateBookmark.value = false
    }, 900)

    const bookmarkEl = bookmarkButtonRef.value
    const modalEl = modalContainerRef.value
    if (!bookmarkEl || !modalEl || typeof window === 'undefined') return

    const bookmarkRect = bookmarkEl.getBoundingClientRect()
    const modalRect = modalEl.getBoundingClientRect()
    const startX = modalRect.left + (modalRect.width / 2)
    const startY = modalRect.top + (modalRect.height / 2)
    const endX = bookmarkRect.left + (bookmarkRect.width / 2)
    const endY = bookmarkRect.top + (bookmarkRect.height / 2)

    savePulseStyle.value = {
        '--pulse-start-x': `${startX}px`,
        '--pulse-start-y': `${startY}px`,
        '--pulse-end-x': `${endX}px`,
        '--pulse-end-y': `${endY}px`
    }

    showSavePulse.value = true
    window.setTimeout(() => {
        showSavePulse.value = false
    }, 650)
}

onMounted(() => {
    searchQuery.value = currentSearchUrl.value
    document.addEventListener('mousedown', handleDocumentPointerDown)
    document.addEventListener('touchstart', handleDocumentPointerDown)
})

onBeforeUnmount(() => {
    document.removeEventListener('mousedown', handleDocumentPointerDown)
    document.removeEventListener('touchstart', handleDocumentPointerDown)
    clearSilentMatchLoadTimeout()
})

watch([isAuthenticated, isAuthBootstrapReady, isAuthTokenReady, currentQuery, currentSearchUrl], () => {
    if (!isAuthenticated.value) {
        clearSilentMatchLoadTimeout()
        closeDashboardActivationModal()
        savedSearchMatch.value = null
        dashboardActivationStatus.value = 'unknown'
        dashboardActivationCheckedUser.value = ''
        dashboardActivationCheckPromise = null
        if (!isModalOpen.value) {
            isUpdateMode.value = false
            updateSearchId.value = ''
            searchName.value = ''
        }
        return
    }

    if (!hasSearchToCheck.value) {
        clearSilentMatchLoadTimeout()
        loadSavedSearchMatch()
        return
    }

    // Wait until auth startup has resolved user context and RPT token before silent matching.
    if (!isAuthBootstrapReady.value) return
    if (!isAuthTokenReady.value) return

    scheduleSilentMatchLoad()
}, { immediate: true })

watch(() => getDashboardUserIdentity(), (nextUser, previousUser) => {
    if (!isAuthenticated.value) return
    if (!nextUser) return
    if (nextUser === previousUser) return

    dashboardActivationStatus.value = 'unknown'
    dashboardActivationCheckedUser.value = ''
    dashboardActivationCheckPromise = null
})


const saveSearch = async () => {
    const wasUpdateRequest = isUpdateMode.value
    try {
        const ensureNonEmptyString = (value, fallback) => {
            if (typeof value !== 'string') return fallback
            const trimmed = value.trim()
            return trimmed.length > 0 ? trimmed : fallback
        }

        const buildAttributesPayload = () => {
            const defaultResultResponse = isUpdateMode.value ? 'updated result response' : 'result response'
            const existingResultResponse = savedSearchMatch.value?.attributes?.field_result_response
            const normalizedQuery = ensureNonEmptyString(searchQuery.value, currentSearchUrl.value || '')
            const queryCandidate = normalizedQuery.includes('://')
                ? normalizedQuery
                : (currentSearchUrl.value || normalizedQuery)
            const queryToSave = ensureDataPath(queryCandidate)

            return {
                field_result_response: ensureNonEmptyString(existingResultResponse, defaultResultResponse),
                field_search_url: {
                    uri: queryToSave
                },
                field_search_string: queryToSave,
                field_title: ensureNonEmptyString(searchName.value, 'Saved search')
            }
        }

        const buildApiPayload = () => ({
            // Keep both REST-style top-level fields and JSON:API structure for backend compatibility.
            ...buildAttributesPayload(),
            ...(isUpdateMode.value ? {} : { bundle: 'combined_search' }),
            data: {
                attributes: {
                    ...buildAttributesPayload(),
                    ...(isUpdateMode.value ? {} : { bundle: 'combined_search' })
                },
                type: 'dash_saved_search'
            }
        })

        const buildJsonApiPatchPayload = () => ({
            data: {
                id: updateSearchId.value,
                type: savedSearchMatch.value?.type || 'node--dash_saved_search',
                attributes: {
                    ...buildAttributesPayload()
                }
            }
        })

        const executeSave = async (token, csrfToken = '', omitCookies = false) => {
            if (isUpdateMode.value) {
                const updateUrl = `${savedSearchRestApiBase}/update/${updateSearchId.value}`
                try {
                    if (omitCookies) {
                        return await executeCookielessRequest({
                            url: updateUrl,
                            method: 'POST',
                            headers: getAuthHeaders(token, 'application/json', csrfToken),
                            payload: buildApiPayload()
                        })
                    }

                    return await axios.post(updateUrl, buildApiPayload(), {
                        headers: getAuthHeaders(token, 'application/json', csrfToken)
                    })
                } catch (error) {
                    if (error?.response?.status !== 405) throw error

                    // Fallback: update through Drupal JSON:API resource endpoint.
                    const jsonApiUpdateUrl = `${savedSearchJsonApiBase}/${updateSearchId.value}`
                    if (omitCookies) {
                        return await executeCookielessRequest({
                            url: jsonApiUpdateUrl,
                            method: 'PATCH',
                            headers: getAuthHeaders(token, 'application/vnd.api+json', csrfToken),
                            payload: buildJsonApiPatchPayload()
                        })
                    }

                    return await axios.patch(jsonApiUpdateUrl, buildJsonApiPatchPayload(), {
                        headers: getAuthHeaders(token, 'application/vnd.api+json', csrfToken)
                    })
                }
            }

            const createUrl = `${savedSearchRestApiBase}/create`
            if (omitCookies) {
                return await executeCookielessRequest({
                    url: createUrl,
                    method: 'POST',
                    headers: getAuthHeaders(token, 'application/json', csrfToken),
                    payload: buildApiPayload()
                })
            }

            return await axios.post(createUrl, buildApiPayload(), {
                headers: getAuthHeaders(token, 'application/json', csrfToken)
            })
        }

        let token = mockToken.value || await fetchDashboardToken()
        if (!token) throw new Error('No dashboard token received')
        let csrfToken = await fetchDrupalCsrfToken()

        let response
        try {
            response = await executeSave(token, csrfToken)
        } catch (error) {
            // Retry once with a newly issued token when backend returns Unauthorized.
            if (error?.response?.status === 401) {
                token = await fetchDashboardToken({ forceRefresh: true })
                if (!token) throw error
                response = await executeSave(token, csrfToken)
            } else if (error?.response?.status === 403) {
                // When a Drupal session cookie is active, mutating requests may require a fresh X-CSRF-Token.
                csrfToken = await fetchDrupalCsrfToken({ forceRefresh: true })
                try {
                    response = await executeSave(token, csrfToken)
                } catch (retryError) {
                    if (retryError?.response?.status !== 403) throw retryError

                    // As a last resort, avoid sending Drupal session cookies and rely on bearer token only.
                    token = await fetchDashboardToken({ forceRefresh: true })
                    if (!token) throw retryError
                    csrfToken = await fetchDrupalCsrfToken({ forceRefresh: true })
                    response = await executeSave(token, csrfToken, true)
                }
            } else {
                throw error
            }
        }

        if (response.status >= 200 && response.status < 300) {
            const responseId = response?.data?.id || response?.data?.data?.id || updateSearchId.value
            const responseType = response?.data?.type || response?.data?.data?.type || savedSearchMatch.value?.type || 'node--dash_saved_search'
            const normalizedQuery = typeof searchQuery.value === 'string' && searchQuery.value.trim().length > 0
                ? searchQuery.value.trim()
                : currentSearchUrl.value
            const queryCandidate = normalizedQuery.includes('://') ? normalizedQuery : currentSearchUrl.value
            const normalizedSavedUrl = ensureDataPath(queryCandidate)

            // Optimistically mark current query as saved so the icon fills immediately.
            savedSearchMatch.value = {
                id: responseId,
                type: responseType,
                attributes: {
                    field_search_url: {
                        uri: normalizedSavedUrl
                    },
                    field_search_string: normalizedSavedUrl,
                    field_title: searchName.value
                }
            }
            isUpdateMode.value = true
            updateSearchId.value = responseId || updateSearchId.value
            triggerBookmarkSuccessAnimation()

            store.dispatch('snackbar/showSnackbar', {
                message: wasUpdateRequest ? 'Search updated successfully' : 'Saved Successfully',
                variant: 'success'
            });
            closeModal();
            // Keep optimistic state to avoid stale-read flicker, then refresh in background.
            void loadSavedSearchMatch({ interactive: true, preserveExistingMatch: true })
        }
    }
    catch (error) {
          const status = error?.response?.status
          if (status === 401) {
              store.dispatch('snackbar/showSnackbar', {
                  message: 'Saving the Search was not sucessful. (Error 401: Unauthorized)',
                  variant: 'error'
              })
              return
          }
          if (status === 403) {
              store.dispatch('snackbar/showSnackbar', {
                  message: 'Permission denied while saving search. Please refresh the page and try again.',
                  variant: 'error'
              })
              return
          }
          console.error('Error saving search:', error);
          store.dispatch('snackbar/showSnackbar', {
              message: wasUpdateRequest ? 'Error updating search' : 'Error saving search',
              variant: 'error'
          });
      }

}

const deleteSearch = async () => {
    if (isDeletingSearch.value) return

    const deleteId = updateSearchId.value || savedSearchMatch.value?.id
    if (!deleteId) {
        store.dispatch('snackbar/showSnackbar', {
            message: 'No saved search found to delete',
            variant: 'error'
        })
        return
    }

    const executeDelete = async (token, csrfToken = '', omitCookies = false) => {
        const restDeleteUrl = `${savedSearchRestApiBase}/delete/${deleteId}`
        try {
            if (omitCookies) {
                return await executeCookielessRequest({
                    url: restDeleteUrl,
                    method: 'POST',
                    headers: getAuthHeaders(token, 'application/json', csrfToken),
                    payload: {}
                })
            }

            return await axios.post(restDeleteUrl, {}, {
                headers: getAuthHeaders(token, 'application/json', csrfToken)
            })
        } catch (error) {
            const status = error?.response?.status
            if (status !== 404 && status !== 405) throw error

            // Fallback: delete through Drupal JSON:API resource endpoint.
            const jsonApiDeleteUrl = `${savedSearchJsonApiBase}/${deleteId}`
            if (omitCookies) {
                return await executeCookielessRequest({
                    url: jsonApiDeleteUrl,
                    method: 'DELETE',
                    headers: getAuthHeaders(token, 'application/vnd.api+json', csrfToken)
                })
            }

            return await axios.delete(jsonApiDeleteUrl, {
                headers: getAuthHeaders(token, 'application/vnd.api+json', csrfToken)
            })
        }
    }

    isDeletingSearch.value = true

    try {
        let token = mockToken.value || await fetchDashboardToken()
        if (!token) throw new Error('No dashboard token received')
        let csrfToken = await fetchDrupalCsrfToken()

        try {
            await executeDelete(token, csrfToken)
        } catch (error) {
            if (error?.response?.status === 401) {
                token = await fetchDashboardToken({ forceRefresh: true })
                if (!token) throw error
                await executeDelete(token, csrfToken)
            } else if (error?.response?.status === 403) {
                csrfToken = await fetchDrupalCsrfToken({ forceRefresh: true })
                try {
                    await executeDelete(token, csrfToken)
                } catch (retryError) {
                    if (retryError?.response?.status !== 403) throw retryError

                    token = await fetchDashboardToken({ forceRefresh: true })
                    if (!token) throw retryError
                    csrfToken = await fetchDrupalCsrfToken({ forceRefresh: true })
                    await executeDelete(token, csrfToken, true)
                }
            } else {
                throw error
            }
        }

        savedSearchMatch.value = null
        isUpdateMode.value = false
        updateSearchId.value = ''
        searchName.value = ''
        searchQuery.value = currentSearchUrl.value
        closeDropdown()
        closeModal()
        // Close immediately on success even while isDeletingSearch is still true.
        isDeleteConfirmOpen.value = false

        store.dispatch('snackbar/showSnackbar', {
            message: 'Search deleted successfully',
            variant: 'success'
        })
    } catch (error) {
        const status = error?.response?.status
        if (status === 401) {
            store.dispatch('snackbar/showSnackbar', {
                message: 'Please create an account in the collaboration channel to save your searches.',
                variant: 'error'
            })
            return
        }
        if (status === 403) {
            store.dispatch('snackbar/showSnackbar', {
                message: 'Permission denied while deleting search. Please refresh the page and try again.',
                variant: 'error'
            })
            return
        }

        console.error('Error deleting search:', error)
        store.dispatch('snackbar/showSnackbar', {
            message: 'Error deleting search',
            variant: 'error'
        })
    } finally {
        isDeletingSearch.value = false
    }
}

</script>

<style scoped>
.search-save {
    position: relative;
}

.bookmark-btn {
    background: #0e47cb;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
}

.bookmark-btn--saved {
    background: #0e47cb;
}

.bookmark-btn--animate-success {
    animation: bookmark-pop 0.5s ease-out;
}

.bookmark-btn--animate-success svg {
    animation: bookmark-glow 0.8s ease-out;
}

.bookmark-btn:hover {
    background-color: #0e47cb;
}

.bookmark-save-pulse {
    position: fixed;
    width: 14px;
    height: 14px;
    border-radius: 999px;
    pointer-events: none;
    z-index: 1200;
    left: var(--pulse-start-x);
    top: var(--pulse-start-y);
    background: radial-gradient(circle, rgba(14, 71, 203, 0.95) 20%, rgba(14, 71, 203, 0.15) 75%);
    transform: translate(-50%, -50%);
    animation: save-pulse-to-bookmark 0.65s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes save-pulse-to-bookmark {
    0% {
        left: var(--pulse-start-x);
        top: var(--pulse-start-y);
        transform: translate(-50%, -50%) scale(0.9);
        opacity: 0;
    }
    15% {
        opacity: 1;
    }
    100% {
        left: var(--pulse-end-x);
        top: var(--pulse-end-y);
        transform: translate(-50%, -50%) scale(0.2);
        opacity: 0;
    }
}

@keyframes bookmark-pop {
    0% {
        transform: scale(1);
    }
    40% {
        transform: scale(1.18);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes bookmark-glow {
    0% {
        filter: drop-shadow(0 0 0 rgba(255, 255, 255, 0));
    }
    45% {
        filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.9));
    }
    100% {
        filter: drop-shadow(0 0 0 rgba(255, 255, 255, 0));
    }
}

@media (prefers-reduced-motion: reduce) {
    .bookmark-btn--animate-success,
    .bookmark-btn--animate-success svg,
    .bookmark-save-pulse {
        animation: none;
    }
}

/* Dropdown Styles */
.dropdown-overlay {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 999;
}

.dropdown-divider {
    margin: 0px
}

.dropdown-content {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border: 1px solid #e0e0e0;
    min-width: 200px;
    z-index: 1000;
}

.dropdown-item {
    width: 100%;
    padding: 12px 16px;
    border: none;
    background: none;
    text-align: left;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #333;
    font-size: 14px;
    transition: background-color 0.2s;
    color: #0e47cb;
}

.dropdown-item:first-child {
    border-radius: 8px 8px 0 0;
}

.dropdown-item:last-child {
    border-radius: 0 0 8px 8px;
}

.dropdown-item:hover {
    background-color: #f5f5f5;
    color: #0E47CB;
}

.dropdown-item--danger {
    color: #b42318;
}

.dropdown-item--danger svg {
    color: #b42318;
}

.dropdown-item--danger:hover {
    background-color: #fef3f2;
    color: #912018;
}

.plus-icon {
    font-size: 16px;
    font-weight: bold;
    color: #0e47cb;
    width: 16px;
    text-align: center;
}

.dropdown-item svg {
    color: #0e47cb;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-container {
    width: 90%;
    max-width: 600px;
    position: relative;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.close-button {
    position: absolute;
    top: 15px;
    right: 20px;
    background: none;
    border: none;
    font-size: 14px;
    color: #0e47cb;
    cursor: pointer;
    padding: 5px;
    z-index: 111111;
}

.close-button:hover {
    color: #495057;
}

.modal-content {
    padding: 40px 40px 30px 40px;
}

.modal-title {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 30px;
    color: #333;
}

.form-group {
    margin-bottom: 25px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
}

.form-control {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e9ecef;
    border-radius: 4px;
    font-size: 16px;
    transition: border-color 0.15s ease-in-out;
    box-sizing: border-box;
}

.form-control--suggestion {
    color: #959595;
}

.form-control--readonly-query {
    background-color: #f1f3f5;
    color: #6b7280;
    pointer-events: none;
    cursor: default;
}

.form-control:focus {
    outline: none;
    border-color: #0e47cb;
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
}

.modal-footer {
    margin-top: 30px;
}

.save-button {
    background-color: #0e47cb;
    border: none;
    padding: 12px 24px;
    border-radius: 4px;
    color: white;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.15s ease-in-out;
}

.cancel-button {
    padding: 12px 24px;
    border-radius: 4px;
}

.save-button:hover:not(:disabled) {
    background-color: #0e47cb;
}

.save-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}


.debug-title {
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #495057;
}

.debug-content {
    margin: 0;
    max-height: 220px;
    width: 800px;
    overflow: auto;
    font-size: 12px;
    color: #212529;
    white-space: pre-wrap;
    word-break: break-word;
}

.confirm-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1100;
}

.confirm-modal {
    width: 90%;
    max-width: 360px;
    background: #fff;
    border: 1px solid #e6e8ec;
    border-radius: 8px;
    box-shadow: 0 14px 40px rgba(0, 0, 0, 0.2);
    padding: 16px;
}

.confirm-modal__title {
    margin: 0;
    font-size: 18px;
    color: #111827;
}

.confirm-modal__text {
    margin: 8px 0 16px;
    font-size: 14px;
    color: #374151;
}

.confirm-modal__actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.confirm-modal__btn {
    border: 1px solid #d1d5db;
    border-radius: 4px;
    background: #fff;
    color: #111827;
    padding: 8px 12px;
    font-size: 14px;
    cursor: pointer;
}

.confirm-modal__btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.confirm-modal__btn--danger {
    border-color: #b42318;
    background: #b42318;
    color: #fff;
}

.confirm-modal__btn--danger:hover:not(:disabled) {
    background: #912018;
    border-color: #912018;
}

.confirm-modal__btn--cancel:hover:not(:disabled) {
    background: #f3f4f6;
}

.activation-modal__text {
    margin: 8px 0 12px;
    font-size: 14px;
    color: #374151;
}
</style>

